import React from 'react';
import Breadcrumbs from 'Header/Breadcrumbs';
import Gallery from 'ProductPageRestructure/Gallery';
import Description from 'ProductPageRestructure/Description';
import Boxes from 'ProductPageRestructure/Boxes';
import DiscoverMore from 'ProductPageRestructure/DiscoverMoreTreatments';
import CustomersAlsoLiked from 'ProductPageRestructure/RelatedContent';
import BottonPushes from 'Shared/BottonPushes';
import useMatchMedia from "hooks/useMatchMedia";
import { BVRatingButton } from "BVRating/BVRatingButton/BVRatingButton";
import { BVRatingForm } from "BVRating/BVRatingForm/BVRatingForm";

const ProductPage = (props) => {
    const isMobile = useMatchMedia('(max-width: 767px)');
    const isDesktop = useMatchMedia('(min-width: 1025px)')

    const {
        ProductSlider,
        YoutubeSlider,
        DiscoverMoreTreatments,
        RelatedContent,
        DetailsImage,
        DetailsImageAlt,
        Sku,
        BottomTiles,
        Id,
        FriendlyName,
    } = props.product.Model;

    const bvId = Id;

    return (
        <div className="main">
            <Breadcrumbs breadcrumbProps={props.breadcrumbs.Breadcrumb} />
            <div className="product-top-wrapper">
                <Gallery
                    productSlides={ProductSlider}
                    youtubeSlides={YoutubeSlider}
                    detailsImage={DetailsImage}
                    detailsImageAlt={DetailsImageAlt}
                    isMobile={isMobile}
                />
                <Description {...props} isDesktop={isDesktop} bvId={bvId} />
            </div>
            <Boxes
                {...props}
                isMobile={isMobile}
            />

            {DiscoverMoreTreatments.length > 0 && (
                <DiscoverMore {...DiscoverMoreTreatments[0]} isDesktop={isDesktop} />
            )}
            {RelatedContent.length > 0 && (
                <CustomersAlsoLiked
                    {...RelatedContent[0]}
                    isMobile={isMobile}
                />
            )}
            <BVRatingForm productId={bvId}/>
            <BottonPushes
                salonFinder={props.product.Model}
                bottonPushes={BottomTiles}
                salonCountries={props.salonCountries}
            />
            <BVRatingForm productId={bvId}/>
                <div className="bazaar-voice-container">
                    <div data-bv-show="reviews" data-bv-product-id={bvId}></div>
                    <BVRatingButton/>
            </div>
            {props.product.Model.Id && (
                <div className="main">
                </div>
            )}
        </div>
    );
}
export default ProductPage;
